export default {
    id: null,
    descricao: null,
    pessoa: null,
    tipo: null
}
